import { render, staticRenderFns } from "./InputZone.vue?vue&type=template&id=2bc68f18&scoped=true&"
import script from "./InputZone.vue?vue&type=script&lang=js&"
export * from "./InputZone.vue?vue&type=script&lang=js&"
import style0 from "./InputZone.vue?vue&type=style&index=0&id=2bc68f18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc68f18",
  null
  
)

export default component.exports